<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />
    <v-layout fill-height>
      <scroll-table
        :data="getTable"
        :options="options"
        :sortable="false"
        :translate="false"
        :subscribed="true"
        :toolbar="'services'"
        @select=""
      />
    </v-layout>
  </v-container>
</template>

<script>

import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'

export default {

  name: 'LOCATION_CONNECTIONS_MODAL',

  components: {
    scrollTable,
    loadingCircle,
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },

  data: () => ({
    loader: false,
    options: {
      columns: {
        text: {
          width: '40%'
        },
        timestamp: {
          width: '40%'
        },
        timestamp: {
          width: '40%'
        },
        actions: {
          width: '40%'
        },
        endpoint: {
          width: '40%'
        },
        check: {
          width: '20%'
        },
      },
    },
    filter: null,
    search: '',
    table: {
      columns: [
        {
          title: 'name',
          value: 'name',
          type: 'text',
          width: '70%'
        },
        {
          title: 'type',
          value: 'type',
          type: 'text',
          width: '30%'
        },
      ],
      rows: []
    },
  }),

  computed: {
    getTable: function () {
      let t = this.$merge({}, this.table)
      return t
    },
  },

  watch: {},

  created () {
    this.setup()
  },

  mounted () {},

  updated () {},

  beforeDestroy () {},

  methods: {
    setup: async function () {
      console.log(this.$options.name, 'statusSubscribe', 'data', this.data)
      this.reset()
      this.statusUnsubscribe(this.$options.name)
      this.prepareTable()
    },

    prepareTable: async function () {
      try {
        if(!this.data.brefs || !this.data.brefs.length) return
          this.loader = true
          this.data.brefs.forEach(bref => {
            if(bref.ref && bref.ref == 'connection') {
              this.table.rows.push(bref)
            }       
          })
          console.log(this.$options.name, 'prepareTable', 'this.table', this.table)
          this.loader = false
          this.statusSubscribe(this.table.rows, this.$options.name)
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'prepareTable', err)
        this.loader = false
      }

    },

    statusSubscribe: async function (arr, group) {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      if(arr.length) {
        arr.forEach((item, i) => {
          if(item.$id) {
            this.$store.dispatch('addStatusKey',item)
          }
        });
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler: function (e) {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe: function (group) {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    reset: function () {
      this.table.rows = []
    }

  }

}
</script>

<style scoped lang="less">

</style>
